import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Polygon 18",
		d: "M4.5 7.5L0.602885 0.75L8.39711 0.750001L4.5 7.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFilledArrow);
export { ForwardRef as ReactComponent };
